<template>
  <header class="page-header">
    <div class="nav" :class="{
      'menu-open': viewportWidth <= 768 && isMenuOpen,
      'sub-open': viewportWidth <= 768 && isMenuOpen && isSubOpen
    }">
      <div :class="{ 'main-header': viewportWidth > 768 }">
        <div v-if="viewportWidth > 768" class="main-header-blur-bg"></div>
        <div class="nav-container">
          <!-- hamburger button only on small screen -->
          <button v-if="viewportWidth <= 768" class="menu-icon" @click.stop="toggleMenu" :aria-label="isMenuOpen ? 'بستن منو' : 'باز کردن منو'">
            <img :src="menuIcon" alt="">
          </button>
          <!-- logo -->
          <a href="/" class="nav-logo">
            <img src="./assets/images/onclick.png" alt="آن کلیک - بازگشت به صفحه اصلی"/>
          </a>
          <!-- Desktop Menu -->
          <nav v-if="viewportWidth > 768" class="desktop-nav">
            <ul class="desktop-menu">
              <li><router-link to="/" active-class="">آن کلیک</router-link></li>
              <li><router-link to="/blog">مقالات</router-link></li>
          <div class="submenu-container">
              <button class="services-btn" @click.stop="toggleSub">
                <span class="text">خدمات</span>
                <span class="services-btn-icon" :class="{ 'sub-close': isSubOpen }"></span>
              </button>
              <div v-if="isSubOpen" class="submenu" v-click-outside="closeOutside" @click="handleSubmenuClick">
                <img class="subtract" src="./assets/images/Subtract.png" alt="">
                <div class="submenu-content">
                  <div class="services">
                    <h3>خدمات</h3>
                    <p>
                      آن کلیک پلتفرم رسمی تبلیغات در فیلو می‌باشد که خدماتی مانند تبلیغات ویدیویی، بنری و همسان را به
                      مشتریان خود ارائه می‌دهد.
                    </p>
                  </div>
                  <ul class="ads">
                    <h3>تبلیغات</h3>
                    <li>
                      <img src="./assets/images/video.png" alt="">
                      <router-link to="/ads/video" class="submenu-item">تبلیغات ویدیویی</router-link>
                    </li>
                    <li>
                      <img src="./assets/images/advertising.png" alt="">
                      <router-link to="/ads/native" class="submenu-item">تبلیغات همسان </router-link>
                    </li>
                    <li>
                      <img src="./assets/images/advertisement.png" alt="">
                      <router-link to="/ads/banner" class="submenu-item">تبلیغات بنری </router-link>
                    </li>
                  </ul>
                </div>
              </div>
          </div>
              <li><router-link to="/tariff">تعرفه</router-link></li>
            </ul>
          </nav>
          <!-- login button only on larg screen -->
          <a v-if="viewportWidth > 768" :href="isLoggedIn ? campaignPath : loginPath" class="btn btn--primary nav-btn">
             <img :src="btnSrc" alt="" class="icon" />
             <span> {{ isLoggedIn ? 'شروع تبلیغ' : 'ورود / ثبت نام' }} </span>
          </a>
          <!-- Mobile Menu -->
          <div v-if="viewportWidth <= 768 && isMenuOpen" class="mobile-nav" v-click-outside="closeOutside">
            <ul class="mobile-menu" @click="handleSubmenuClick">
              <li><router-link to="/" active-class="" class="menu-item">آن کلیک</router-link></li>
              <li><router-link to="/blog" class="menu-item">مقالات</router-link></li>
              <div class="services">
                <button class="services-btn" @click="toggleSub">
                  <span>خدمات</span>
                  <span class="services-btn-icon" :class="{ 'sub-close': isSubOpen }"></span>
                </button>
                <ul v-if="isSubOpen" class="services-list" @click="handleSubmenuClick">
                  <li><router-link to="/ads/video" class="submenu-item">تبلیغات ویدیویی</router-link></li>
                  <li> <router-link to="/ads/native" class="submenu-item">تبلیغات همسان </router-link></li>
                  <li><router-link to="/ads/banner" class="submenu-item">تبلیغات بنری </router-link></li>
                </ul>
              </div>
              <li><router-link to="/tariff" class="menu-item">تعرفه</router-link></li>
            </ul>
            <!-- login button -->
             <a :href="isLoggedIn ? campaignPath : loginPath" class="btn btn--primary nav-btn">
                 <img :src="btnSrc" alt="" class="icon" />
                 <span> {{ isLoggedIn ? 'شروع تبلیغ' : 'ورود / ثبت نام' }} </span>
             </a>
          </div>
        </div>
      </div>
      <!--hero header only on larg screen -->
      <div v-if="viewportWidth > 768" class="hero-header">
        <div :class="[
          'header-content',
          { 'fade-in': !isVisible, 'fade-out': isVisible },
        ]">
          <div class="header-container">
            <span class="header-txt">
             با آن کلیک همه میبیننت، همه میشناسنت!
            </span>
            <a href="tel:+9801344994" class="contact-us">
              <span>01344994</span>
              <img src="./assets/images/call.svg" alt="" />
            </a>
          </div>
        </div>
        <div :class="['progress-bar', { stick: !isVisible }]">
          <span class="spend-bar" :style="{ width: barWidth }"></span>
        </div>
      </div>
    </div>
  </header>
  <main class="page-main">
    <router-view></router-view>
    <button type="button" class="scroll-top" @click="scrollToTop" aria-label="بازگشت به بالای صفحه"  v-show="showScrollTop">
      <img src="./assets/images/scroll-top.svg" alt="">
    </button>
  </main>
  <footer class="page-footer">
    <div class="footer-content">
      <a href="/" class="footer-logo">
            <img src="./assets/images/onclick-full.png" alt="آن کلیک - بازگشت به صفحه اصلی"/>
      </a>
      <div class="footer-txt">
        <h2>سرویس تبلیغات آنلاین | آن کلیک</h2>
        <p>سرویس تبلیغات آنلاین آن کلیک، به عنوان پلتفرم رسمی تبلیغات در فیلو، امکان دسترسی به میلیون ها کاربر
          فعال را برای شما فراهم می کند. با استفاده از خدمات تبلیغاتی متنوع ما، از جمله تبلیغات ویدیویی، بنری و همسان،
          برند خود را به طور گسترده تبلیغ کنید.
        </p>
      </div>
      <div v-if="viewportWidth > 768" class="address">
        <p class="address-title">ارتباط با ما</p>
        <p>آدرس: رشت، میدان سرگل، ساختمان LB، طبقه 3، واحد 5، شرکت ایده پردازان درفک </p>
        <a href="tel:+9801344994"> تلفن: 01344994</a>
      </div>
      <div class="links">
        <p class="links-title">لینک های مفید</p>
        <ul>
          <li><a :href="loginPath"> ثبت نام</a></li>
          <li><router-link to="/blog">مقالات</router-link></li>
          <li><router-link to="/tariff">تعرفه</router-link></li>
        </ul>
      </div>
      <div class="license">
        <p class="license-title">مجوز ها</p>
        <div class="license-item">
         <div><a rel="nofollow" referrerPolicy='origin' target='_blank' href='https://trustseal.enamad.ir/?id=428590&Code=DFx4O1gf2RROfGAhLi2uG4Mx9a7b3WRV'><img referrerPolicy='origin' src='https://trustseal.enamad.ir/logo.aspx?id=428590&Code=DFx4O1gf2RROfGAhLi2uG4Mx9a7b3WRV' alt='' style='cursor:pointer' code='DFx4O1gf2RROfGAhLi2uG4Mx9a7b3WRV'></a></div>
          <div><a target="_blank" href="https://logo.samandehi.ir/Verify.aspx?id=312613&p=xlaorfthuiwkgvkarfthxlao"
            rel="nofollow">
            <img src="./assets/images/samandehi.png" alt="تبلیغات اینترنتی آن کلیک" id="rgvjjxlznbqefukzjxlzrgvj">
          </a></div>
        </div>
      </div>
      <div class="social">
        <p class="social-title">شبکه های اجتماعی</p>
        <div class="social-container">
            <a href="https://ifilo.net/onclick" target="_blank" rel="noopener noreferrer">
                <img src="./assets/images/filo.png" alt="فیلو آن کلیک">
            </a>
            <a href="https://www.instagram.com/onclick.ir/" target="_blank" rel="nofollow">
                <img src="./assets/images/instagram.png" alt="اینستاگرام آن کلیک">
            </a>
        </div>
      </div>
    </div>
    <div class="bottom-bar">
      <div class="copyright">
        <img src="./assets/images/copyright.svg" alt="" class="icon">
        <span> محصولی از خانواده <a target="_blank" href="https://dorfaksoft.com/">ایده پردازان درفک</a></span>
      </div>
    </div>
  </footer>
</template>

<script>
import axios from 'axios';
import { ref, provide, computed, onMounted, onBeforeUnmount } from "vue";
axios.defaults.withCredentials = true;
export default {
  name: "App",
  setup() {
    // update width
    const viewportWidth = ref(window.innerWidth);
    const updateWidth = () => {
      viewportWidth.value = window.innerWidth;
    }
    provide('viewportWidth', viewportWidth);

    // scroll to top 
    const scrollToTop = () => {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    };

    // Login info
    const isLoggedIn = ref(false);

    provide('isLoggedIn', isLoggedIn);

    async function getLoggedInInfo() {
        try {
            const response = await axios({
              method: 'POST',
              url: `${process.env.VUE_APP_ONCLICK_API_DOMAIN}/bind/master`,
            });
            isLoggedIn.value = response.data.il;
        } catch (err) {
            console.error('خطا در دریافت اطلاعات:', err);
        }
    }

    // declare Path
    //const domain = process.env.VUE_APP_ONCLICK_API_DOMAIN;
    const panelDomain = process.env.VUE_APP_ONCLICK_PANEL_DOMAIN;
    const campaignPath = ref(`${panelDomain}/campaign/add`);
    const loginPath = ref(`${panelDomain}/login`);
    const registerPath = ref(`${panelDomain}/register`);
    provide('campaignPath', campaignPath);
    provide('loginPath', loginPath);
    provide('registerPath', registerPath);

    const btnSrc = computed(() =>
      isLoggedIn.value
        ? require('@/assets/images/login-bold-duotone.svg')
        : require('@/assets/images/user.svg')
    )
    provide('btnSrc', btnSrc);

    // toggle hamburger menu 
    const isMenuOpen = ref(false);
    const toggleMenu = () => {
      isMenuOpen.value = !isMenuOpen.value;
      if (!isMenuOpen.value) {
        isSubOpen.value = false;
      }
    }

    //hamburger open and close icon
    const menuIcon = computed(() => isMenuOpen.value ? require('@/assets/images/close.svg') : require('@/assets/images/hamburger.svg'));

    // toggle submenu
    const isSubOpen = ref(false);
    const toggleSub = () => {
      isSubOpen.value = !isSubOpen.value;
    }

    // close menu and submenu automatically by clicking everywhere in document
    const closeOutside = () => {
        if (isMenuOpen.value) {
            isMenuOpen.value = false;
        }
        if ( isSubOpen.value) {
            isSubOpen.value = false;
        }
    };

    // close menu and submenu by clicking in any items
    const handleSubmenuClick = (event) => {
      if (event.target.classList.contains('menu-item')) {
        isMenuOpen.value = false;
      }
      if (event.target.classList.contains('submenu-item')) {
        isSubOpen.value = false;
      }
    };

    // close menu and submenu automatically by scrolling
    const closeByScroll = () => {
        closeOutside();
    };

    // show/hide header-content
    const isVisible = ref(true);
    const handleScroll = () => {
      const scrollThreshold = 1;
      isVisible.value = window.scrollY < scrollThreshold;
    };

    // progress bar && // showScrollTop button
    const progress = ref(0);
    const showScrollTop = ref(false);
    const updateProgress = () => {
      const scrollTop = window.scrollY;
      const scrollHeight = document.documentElement.scrollHeight;
      const viewportHeight = window.innerHeight;
      const totalScrollableHeight = scrollHeight - viewportHeight;
      progress.value = Math.round((scrollTop / totalScrollableHeight) * 100);
      showScrollTop.value = progress.value > 30;
      updateWidth();
    };

    // progress bar width
    const barWidth = computed(() => {
      const base = viewportWidth.value <= 1920 ? 60 : 240
      return `calc(${progress.value}% + ${base}px)`
    });

    // update meta tag
    function updateMetaTag(name, content) {
    let tag = document.querySelector(`meta[name="${name}"]`);
    if (!tag) {
        tag = document.createElement('meta');
        tag.setAttribute('name', name);
        document.head.appendChild(tag);
    }
    tag.setAttribute('content', content);
    }
    provide('updateMetaTag', updateMetaTag);

    // update og tag
    function updateOGTag(property, content) {
        let tag = document.querySelector(`meta[property="og:${property}"]`);
        if (!tag) {
            tag = document.createElement('meta');
            tag.setAttribute('property', `og:${property}`);
            document.head.appendChild(tag);
        }
        tag.setAttribute('content', content);
    }
    provide('updateOGTag', updateOGTag);

    // update canonical link
    function updateCanonicalLink(href) {
        let link = document.querySelector('link[rel="canonical"]');
        if (!link) {
            link = document.createElement('link');
            link.setAttribute('rel', 'canonical');
            document.head.appendChild(link);
        }
        link.setAttribute('href', href);
    }
    provide('updateCanonicalLink', updateCanonicalLink);

    onMounted(() => {
      window.addEventListener("scroll", handleScroll);
      window.addEventListener("scroll", updateProgress);
      window.addEventListener("scroll", closeByScroll);
      window.addEventListener("resize", updateProgress);
      getLoggedInInfo();
    });

    onBeforeUnmount(() => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("scroll", updateProgress);
      window.addEventListener("scroll", closeByScroll);
      window.removeEventListener("resize", updateProgress);
    });

    return { scrollToTop, isLoggedIn, campaignPath, btnSrc, loginPath, toggleMenu, isMenuOpen, menuIcon, isSubOpen, toggleSub, closeOutside, handleSubmenuClick, isVisible, viewportWidth, barWidth, showScrollTop };
  },
};
</script>

<style>
@font-face {
  font-family: IRANYekan-Medium;
  src: url(./assets/fonts/IRANYekanXFaNum-Medium.ttf);
}

@font-face {
  font-family: IRANYekanXFaNum-DemiBold;
  src: url(./assets/fonts/IRANYekanXFaNum-DemiBold.ttf);
}

@font-face {
  font-family: IRANYekan-Bold;
  src: url(./assets/fonts/IRANYekanXFaNum-Bold.ttf);
}

@keyframes fadeOut {
  to {
    opacity: 0;
  }
}

@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@keyframes fadeRight {
    from {
        opacity: 0;
        transform: translateX(100%);
    }
    to {
        opacity: 1;
        transform: translateX(0);
    }
}

@keyframes fadeLeft {
      from {
        opacity: 0;
        transform: translateX(-100%);
      }
      to {
        opacity: 1;
        transform: translateX(0);
      }
}

@keyframes rotate {
    0% {
    transform: rotate(0deg);
    }
    100% {
    transform: rotate(360deg);
    }
}

:root {
  --main-pink: #d54474;
  --secondary-pink: #9e3666;
  --shadow-pink: rgba(213, 68, 116, 0.5);
  --shadow-light: rgba(0, 0, 0, 0.25);
  --glass-morphism: rgba(255, 255, 255, 0.1);
}

* {
  direction: rtl;
  font-family: IRANYekan-Medium;
  font-size: 18px;
  box-sizing: border-box;
  margin: 0px;
}

html,
body {
  height: 100%;
  margin: 0;
  padding: 0;
}

#app {
  min-height: 100%;
  flex-direction: column;
}

#app,
.btn--primary,
.nav-container,
.header-container,
.contact-us,
.desktop-menu,
.services-btn,
.services,
.ads,
.ads li,
.mobile-nav,
.mobile-menu,
.services-list,
.social,
.social-container,
.license-item,
.copyright,
.scroll-top {
  display: flex;
}

h1, h2, h3, h4 {
    font-weight: unset;
}

.btn {
  border-radius: 50px;
  padding: 10px 23px;
}

.btn--primary {
    transition: transform 0.3s ease;
    box-shadow: 0px 0px 10px var(--shadow-pink);
    z-index: 4;
}

.btn--primary:hover {
    transform: scale(1.01);
    border-color: var(--secondary-pink);
}

.btn--primary::after {
    content: "";
    position: absolute;
    top: 50%;
    left: 50%;
    width: 0;
    height: 0;
    background-color: var(--secondary-pink);
    border-radius: 50%;
    transform: translate(-50%, -50%);
    opacity: 0;
    transition: width 0.5s ease, height 0.5s ease, opacity 0.5s ease;
    z-index: 1;
}

.btn--primary:hover::after {
    width: 200px;
    height: 200px;
    opacity: 1;
}

.btn--primary,
.btn--info {
  border: 2px solid var(--main-pink);
}

.btn--primary,
.services-list {
  gap: 8px;
}

.btn--primary,
.license-item div {
  overflow: hidden;
}

.btn--primary,
.spend-bar,
.bottom-bar {
  background-color: var(--main-pink);
}

.btn--primary span,
.btn--primary img,
.subtract {
    z-index: 2;
}

.btn--secondary {
  width: 40%;
  margin-inline: auto;
  text-align: center;
  box-shadow: 0px 0px 10px var(--shadow-pink);
  border: 2px solid var(--main-pink);
  background-color: var(--main-pink);
  color: #ffffff;
}

.btn--primary span,
.btn--consult,
.copyright,
.copyright a {
  color: #ffffff;
}

.btn--info {
  transition: all 0.3s ease;
  color: var(--main-pink);
}

.btn--info:hover {
  transform: scale(0.9);
}

.btn--consult {
  background-color: var(--secondary-pink);
  border: 2px solid var(--secondary-pink);
  box-shadow: 0 0 10px var(--shadow-pink);
  transition: all 0.2s ease-in-out;
}

.btn--consult:hover {
  box-shadow: 0 0 20px 6px var(--shadow-pink);
}

.loading {
    font-size: 16px;
    font-family: 'IRANYekan-Bold';
    border: 2px solid var(--main-pink);
    width: fit-content;
    padding: 5px;
    margin-inline: auto;
    margin-top: 60px;
}

.error {
    width: 200px;
    background-color: #f359a91a;
    padding: 1rem;
    margin: 1rem auto;
    text-align: center;
    border-radius: 8px;
}

.error p {
    font-size: 16px;
}

.error button {
    margin-top: 0.5rem;
    padding: 12px;
    background-color: var(--main-pink);
    color: white;
    border: none;
    cursor: pointer;
    border-radius: 50px;
    font-size: 14px;
}

section:not(:first-of-type) {
  margin-top: 6.25%;
}

a {
  text-decoration: none;
}

a,
.btn,
.btn span,
.services-btn span,
.header-txt,
.contact-us span,
.services h3,
.ads h3,
.address-title,
.links-title,
.license-title,
.social-title,
.copyright span {
  font-family: IRANYekan-Bold;
}

.btn,
a,
.services-btn,
.services-list {
  cursor: pointer;
}

ul {
  list-style: none;
}

ul,
.menu-icon,
.services-btn {
  padding: 0;
}

.page-header {
    height: 118px;
}

.nav {
  top: 0;
  z-index: 999;
}

.nav,
.main-header-blur-bg,
.main-header,
.header-content,
.progress-bar {
  right: 0;
}

.nav,
.main-header,
.progress-bar,
.scroll-top {
  position: fixed;
}

.nav,
.main-header-blur-bg,
.main-header,
.nav-container,
.menu-icon img,
.nav-logo img,
.header-content,
.header-container,
.progress-bar,
.page-footer,
license-item a,
.license-item img{
  width: 100%;
}

.nav.menu-open {
  height: 305px;
  border-radius: 25px;
}

.nav.menu-open,
.main-header-blur-bg,
.submenu-content,
.license-item div {
  background-color: var(--glass-morphism);
}

.nav.menu-open,
.main-header-blur-bg,
.submenu-content,
.bottom-bar {
  backdrop-filter: blur(20px);
}

.nav.menu-open,
.scroll-top {
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
}

.nav.sub-open {
  height: 412px;
}

.main-header {
  height: 70px;
  padding: 11px 7.97%;
  z-index: 6;
}

.main-header,
.header-content {
  box-shadow: 0 2px 10px var(--shadow-light);
}

.main-header-blur-bg {
  bottom: 0;
  top: 0;
  z-index: 1;
}

.main-header-blur-bg,
.menu-icon img,
.nav-logo img,
license-item a,
.license-item img {
  height: 100%;
}

.main-header-blur-bg,
.desktop-nav,
.spend-bar,
.submenu,
.subtract,
.mobile-nav {
  position: absolute;
}

.main-header-blur-bg,
.spend-bar {
  left: 0;
}

.btn--primary,
.nav-container,
.desktop-menu,
.services-btn,
.ads li,
.contact-us,
.footer-content,
.social-container,
.copyright,
.scroll-top {
  align-items: center;
}

.nav-container,
.header-container,
.header-content,
.contact-us {
  z-index: 4;
}

.btn--primary,
.nav-container,
.header-container,
.header-content,
.submenu-container,
.contact-us,
.page-footer {
  position: relative;
}

.btn--primary,
.nav-container,
.header-container,
.contact-us,
.ads li,
.footer-content {
  justify-content: space-between;
}

.menu-icon {
  width: 30px;
  height: 30px;
  background-color: unset;
}

.menu-icon,
.services-btn,
.scroll-top {
  border: none;
}

.nav-logo {
    aspect-ratio: 106 / 48;
    max-width: 106px;
    max-height: 48px;
}

.nav-logo img {
    object-fit: contain;
}

.hero-header {
  height: 48px;
}

.desktop-nav {
  margin-right: 196px;
  height: 25px;
}

.desktop-menu {
  gap: 28px;
}

.desktop-menu a:hover,
.mobile-menu :hover,
.links a:hover {
  color: var(--main-pink);
}

.desktop-menu .router-link-active,
.mobile-menu .router-link-active {
  color: var(--main-pink);
}

.desktop-menu a,
.mobile-menu a,
.address a,
.links a,
.error {
  color: #000000;
}

.mobile-menu a,
.services h3,
.ads h3,
.services p,
.footer-txt p,
.address p,
.address a,
.links a {
  font-size: 16px;
  line-height: 28px;
}

.services-btn {
  background-color: inherit;
  color: #000000;
  gap: 3px;
}

.services-btn,
.ads li {
  width: fit-content;
}

.services-btn:hover .text {
  color: var(--main-pink);
}

.services-btn:hover .services-btn-icon {
  background-image: url('./assets/images/submenu-icon-pink.svg');
}

.services-btn-icon {
  background-image: url('./assets/images/submenu-icon.svg');
}

.services-btn-icon,
.icon {
  height: 24px;
}

.services-btn-icon,
.icon,
.contact-us img {
  width: 24px;
}

.sub-close {
  transform: scaleY(-1);
}

.submenu {
  top: 40px;
  right: calc(50% - 259px);
}

.subtract {
  right: calc(50% - 22.5px);
  top: -20px;
}

.submenu-content {
  padding: 32px 27px 23px;
  grid-template-columns: 256px 176px;
  gap: 32px;
  box-shadow: 0 2px 10px rgba(167, 174, 186, 0.1);
  border-radius: 16px;
}

.submenu-content,
.footer-content {
  display: grid;
}

.submenu-content::before {
  content: "";
  position: absolute;
  top: -1px;
  left: -1px;
  right: -1px;
  bottom: -1px;
  z-index: -1;
  background: linear-gradient(90deg,
      rgba(255, 255, 255, 1) 0%,
      rgba(255, 255, 255, 0.2) 50%,
      rgba(255, 255, 255, 1) 100%);
  border-radius: 17px;
  mask:
    linear-gradient(#fff 0 0) content-box,
    linear-gradient(#fff 0 0);
  mask-composite: exclude;
  -webkit-mask-composite: destination-out;
  padding: 1px;
}

.services,
.ads,
.ads li,
.mobile-nav,
.mobile-menu,
.contact-us {
  gap: 16px;
}

.services,
.ads,
.mobile-nav,
.mobile-menu,
.services-list {
  flex-direction: column;
}

.services h3,
.ads h3 {
  height: 21px;
}

.services p {
  line-height: 1.5;
}

.services p,
.footer-txt p {
  text-align: justify;
}

.ads li img {
  width: 32px;
  height: 32px;
}

.mobile-nav {
  top: 60px;
}

.mobile-nav,
.mobile-menu {
  margin-right: 10px;
}

.services-list a {
  font-size: 14px;
  margin-right: 25px;
}

.header-content {
  height: 44px;
  margin-top: 70px;
  background-color: rgba(213, 68, 116, 0.9);
  padding: 10px 7.97%;
  transition: opacity 0.3s ease-in-out;
}

.header-content,
.progress-bar,
.spend-bar {
  backdrop-filter: blur(128px);
}

.fade-in {
  opacity: 0;
}

.fade-out {
  opacity: 1;
}

.header-txt {
  width: 595px;
}

.header-txt,
.contact-us span {
  color: #efefef;
}

.contact-us {
  width: 123px;
}

.contact-us span {
  width: 83px;
  text-align: left;
  align-self: center;
}

.contact-us img {
  height: 22px;
}

.progress-bar {
  background-color: #e7e7e7;
  top: 113px;
  z-index: 5;
}

.progress-bar,
.spend-bar {
  height: 4px;
}

.stick {
  transform: translateY(-44px);
}

.spend-bar {
  display: inline-block;
  box-shadow: 0px 4px 20px var(--shadow-light);
  transition: width 0.3s ease;
}

.spend-bar,
.scroll-top {
  width: 60px;
}

.page-main {
    flex: 1
}

.scroll-top {
  border-radius: 20px;
  aspect-ratio: 1 / 1;
  bottom: 20px;
  right: 20px;
  backdrop-filter: blur(70px);
  z-index: 999;
  justify-content: center;
}

.scroll-top img {
    width: 24px;
    height: 18px;
    object-fit: contain;
}

.page-footer {
  margin-top: -104px;
  border-top-left-radius: 100px;
  border-top-right-radius: 100px;
}

.page-footer,
.scroll-top {
  background-color: #ffffff;
}

.page-footer,
.license-item div {
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.footer-content {
  padding: 31px 13.042% 88px;
  row-gap: 40px;
  grid-template-columns: 33.813% 11.601% 18.796% 14.353%;
}

.footer-logo {
  aspect-ratio: 272 / 143;
  width: 57.35%;
  max-height: 143px;
}

.footer-logo img {
    width: 100%;
    height: 100%;
    object-fit: contain;
}

.footer-txt {
  grid-column: 2 / 5;
  margin-right: -25.4%;
}

.footer-txt h2 {
  font-size: 24px;
  margin-bottom: 26px;
}

.social {
    flex-direction: column;
    align-items: center;
}

.social-container a {
    aspect-ratio: 1 / 1;
    max-height: 40px;
}

.social-container img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.address,
.links,
.license,
.social {
  align-self: start;
}

.address-title {
 font-size: 18px !important;
}

.address-title,
.links-title,
.license-title,
.social-title {
  margin-bottom: 24px;
}

.links {
  justify-self: center;
}

.address a {
    padding-top: 10px;
}

.address a,
.links a {
  font-family: IRANYekan-Medium;
}

.license-item,
.social-container {
  gap: 20px;
}

.license-item div {
  aspect-ratio: 92 / 100;
  max-height: 100px;
  border-radius: 10px;
}

.bottom-bar {
  height: 53px;
}

.copyright {
  gap: 5px;
  width: 307px;
  margin-inline: auto;
  padding-block: 14px;
}

@media screen and (min-width: 1921px) {
  section:not(:first-of-type) {
    margin-top: 120px;
  }

  .nav-container,
  .header-container {
    width: 1614px;
    margin-inline: auto;
  }

  .footer-content {
    width: 1112px;
    margin-inline: auto;
    padding: 31px 0 88px;
  }
}

@media screen and (max-width: 1440px) {
    section:not(:first-of-type) {
    margin-top: 6.95%;
    }

  .btn,
  .btn span {
    font-size: 16px;
  }

  .desktop-menu a,
  .services-btn span,
  .header-txt,
  .contact-us span {
    font-size: 16px;
  }

  .footer-content {
    grid-template-columns: 33.813% 13.601% 18.796% 16.353%;
    row-gap: 30px;
    padding-inline: 7.042%;
    padding-bottom: 30px;
  }

  .footer-txt {
    margin-right: -21.4%;
  }

  .footer-txt h2 {
    margin-bottom: 15px
  }

  .address-title,
  .links-title,
  .license-title,
  .social-title {
    margin-bottom: 15px;
  }
}

@media screen and (max-width: 1024px) {

  .main-header,
  .header-content {
    padding-inline: 5.556%;
  }

  .desktop-nav {
    margin-right: 20.3%;
  }

  .scroll-top {
    border-radius: 15px;
  }

  .footer-content {
    grid-template-columns: 30.813% 15.601% 18.796% 19.353%;
    padding-inline: 6.97%;
  }

  .footer-txt {
      margin-right: -11.4%;
  }

  .footer-txt h2 {
    font-size: 20px;
  }

   .footer-txt p {
    line-height: 26px;
  }

  .address-title,
  .links-title,
  .license-title,
  .social-title {
    font-size: 16px !important;
  }

  .address p,
  .address a,
  .links a {
    font-size: 14px;
  }

  .license-item,
  .social-container {
    gap: 15px;
  }
}

@media screen and (max-width: 768px) {
  .btn {
    height: 44px;
    padding-inline: 16px;
  }

  .page-header {
    height: 66px;
  }

  .nav {
    margin-top: 14px;
    margin-inline: 5.556%;
    width: calc(100% - 11.112%);
    height: 52px;
    box-shadow: 2px 0 8px rgba(0, 0, 0, 0.12);
    border-radius: 100px;
    backdrop-filter: blur(20px);
  }

  .nav-container {
    padding: 4px 3.7%;
  }

  .nav-logo {
    width: 71px;
    height: 44px;
  }

  .services {
    gap: 8px;
  }

  .nav-btn {
    margin-top: 7px;
  }

  .page-footer {
    border-top-left-radius: 50px;
    border-top-right-radius: 50px;
  }

  .footer-content {
    grid-template-columns: 28.601% 11.796% 8.353%;
    justify-items: center;
    row-gap: 20px;
    column-gap: 15px;
    padding-inline: 7%;
    padding-bottom: 35px;
  }

  .footer-logo {
    width: 33.59%;
    max-height: 63px;
    grid-column: 1 / 5;
    justify-self: center;
  }

  .footer-txt {
    grid-column: 1 / 5;
    margin-right: 0;
  }

  .footer-txt h2 {
    font-size: 18px;
    margin-bottom: 12px;
    text-align: center;
  }

  .footer-txt p {
    font-size: 12px;
  }

  .links-title,
  .license-title,
  .social-title {
    font-size: 14px !important;
  }

  .links a {
    font-size: 12px;
  }

  .license {
    grid-column: 2 / 4;
  }

  .license-item,
  .social-container {
        gap: 5px;
  }

  .license-item div {
    max-height: 80px;
  }

  .copyright {
    width: 213px;
  }

  .copyright span,
  .copyright a {
    font-size: 12px;
  }
}

@media screen and (max-width: 425px) {
    .scroll-top {
        width: 50px;
    }
}

@media screen and (max-width: 360px) {
    section:not(:first-of-type) {
        margin-top: 14.23%;
    }

  .btn,
  .btn span {
    font-size: 14px;
  }

  .nav {
    padding-block: 10px;
  }

  .menu-icon {
    width: 24px;
    height: 24px;
  }

  .nav-logo {
    width: 50px;
    height: 24px;
  }

  .footer-content {
    grid-template-columns: 31.601% 15.796% 6.353%;
    padding-inline: 5%;
    column-gap: 7px;
  }

  .social-container a {
    max-height: 30px;
  }
}
</style>
